import React, { createContext, useContext } from "react";
import { useFetchUnwatchedCount } from "./services/api/apis";
import { getRole, isMentorLikeRole } from "../../utils/auth";

const UnwatchedCountContext = createContext({ unwatchedCount: 0, refetchUnwatchedCount: () => {} });

export const useUnwatchedCount = () => useContext(UnwatchedCountContext);

/**
 * Keeps the mentor's "unwatched videos" nav badge live (req 6). Mentor/
 * temp-mentor only. Req 6 only asks that the count reduce on completion —
 * useCoursePlayer's handleVideoComplete already refetches for that, so this
 * is fetch-on-load + that one nudge, no background polling. (A video
 * completed in a *different* tab won't update this tab's badge until
 * reload — an accepted gap.)
 */
export function UnwatchedCountProvider({ children }) {
  const role = getRole();
  const enabled = isMentorLikeRole(role);
  const { apiData, refetch } = useFetchUnwatchedCount({ enabled });

  const unwatchedCount = apiData?.unwatchedCount ?? 0;

  return (
    <UnwatchedCountContext.Provider value={{ unwatchedCount, refetchUnwatchedCount: refetch }}>
      {children}
    </UnwatchedCountContext.Provider>
  );
}
